import { render, staticRenderFns } from "./b_FooterMobile.vue?vue&type=template&id=253e82ae&scoped=true&"
import script from "./b_FooterMobile.vue?vue&type=script&lang=js&"
export * from "./b_FooterMobile.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/footer_mobile.css?vue&type=style&index=0&id=253e82ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e82ae",
  null
  
)

export default component.exports